import React, { useEffect, useState } from 'react'
import Blogs from '../../Reusable/Blogs'
import Bredcrum from '../../common/Bredcrum'
import { blog_data } from './blog_data'
import { axiosInstance } from '../config'

const BlogIndex = () => {

    const [blogs,setblogs] = useState([])
    const [Loading , setLoading] = useState(false);

    useEffect(() => {
        function getBlogs() {
            setLoading(true)

            axiosInstance.get(`get-posts`)
                .then(res => {
                    // console.log(res.data)
                    setblogs(res.data.posts.reverse())
                })
                .catch((err) => console.log(err))
                .finally(() => {
                    setLoading(false)
                })
        }

        getBlogs();
    },[])

    return (
        <>
            <Bredcrum
                heading={'Blog & News'}
                path={[
                    { name: 'Blog & News', path: 'blogs' },
                ]}
            />
            <Blogs blogs={blogs} />
        </>
    )
}

export default BlogIndex